import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { colorVariables } from "../../../utils/colorVariable";
import CustomButton from "../../ui/CustomButton";

interface Props {
  handleClose: () => void;
  onConfirm?: () => void;
  open: boolean;
  title: string;
  children: React.ReactNode;
  color?: string;
  background?: string;
  width?: string;
  isLoading?: boolean;
  isConfirmDisabled?: boolean;
}

export const MiniDialog: React.FC<Props> = ({
  children,
  handleClose,
  onConfirm,
  open,
  title,
  color,
  background,
  width,
  isLoading = false,
  isConfirmDisabled = false,
}) => {
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: width ?? "auto",
          maxWidth: "95vw",
          minWidth: width ? undefined : 400,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "30px",
          px: 2,
          py: 2,
          bgcolor: color ? color : `${colorVariables.red}`,
          background: background ?? "",
        }}
      >
        <Typography
          variant="body1"
          color="initial"
          sx={{ color: colorVariables.white }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>{children}</Box>
      </DialogContent>
      <DialogActions>
        <CustomButton
          variant="outlined"
          onClick={handleClose}
          text={isLoading ? "waiting..." : "Close"}
          bgcolor={colorVariables.white}
          sx={{ borderColor: colorVariables.red, color: colorVariables.red }}
          disabled={isLoading}
        />
        {onConfirm && (
          <CustomButton
            bgcolor={color ? color : colorVariables.red}
            variant="contained"
            onClick={onConfirm}
            text={isLoading ? "waiting..." : "Confirm"}
            background={colorVariables.gradient_primary}
            disabled={isLoading || isConfirmDisabled}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};